import { Box, HStack, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export type WorkforceSubTab = 'meeting-rooms' | 'desks' | 'offices'

const ALL_TAB_KEYS: { key: WorkforceSubTab; labelKey: string }[] = [
  { key: 'meeting-rooms', labelKey: 'planning.tabs.meetingRooms' },
  { key: 'offices', labelKey: 'planning.tabs.offices' },
  { key: 'desks', labelKey: 'planning.tabs.desks' },
]

interface WorkforceTabsProps {
  activeTab: WorkforceSubTab
  onSelectTab: (tab: WorkforceSubTab) => void
  allowedTabs?: string[]
  onTabIntent?: (tab: WorkforceSubTab) => void
}

export default function WorkforceTabs({ activeTab, onSelectTab, allowedTabs, onTabIntent }: WorkforceTabsProps) {
  const { t } = useTranslation()

  const visibleTabs = allowedTabs
    ? ALL_TAB_KEYS.filter((tab) => {
        // "meeting-rooms" UI key maps to "rooms" permission key
        const permKey = tab.key === 'meeting-rooms' ? 'rooms' : tab.key
        return allowedTabs.includes(permKey)
      })
    : ALL_TAB_KEYS

  return (
    <Box width="100%">
      <HStack spacing="24px" align="stretch" pl={5} borderBottomColor="solid.50" borderBottomWidth="1px">
        {visibleTabs.map((tab) => (
          <HStack
            key={tab.key}
            spacing="12px"
            py="18px"
            px="16px"
            height="56px"
            _hover={{ backgroundColor: 'primary.0' }}
            cursor="pointer"
            color="solid.900"
            onClick={() => onSelectTab(tab.key)}
            onMouseEnter={() => onTabIntent?.(tab.key)}
            onFocus={() => onTabIntent?.(tab.key)}
            borderBottomColor={activeTab === tab.key ? 'primary.100' : 'transparent'}
            borderBottomWidth={activeTab === tab.key ? '2px' : '0px'}
          >
            <Text textStyle="l-s" fontSize="13px" fontWeight={activeTab === tab.key ? '600' : '400'}>
              {t(tab.labelKey)}
            </Text>
          </HStack>
        ))}
      </HStack>
    </Box>
  )
}
